module.exports = __webpack_public_path__ + "static/media/group_copy_2@2x.88f95860.png";